import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axiosInstance";

export const createApi = createAsyncThunk(
  "createApi/save",
  async (params: any) => {
    const response = await axiosInstance.post("/featsetup/api", {
      endpointPath: params?.endpointPath,
      apiName: params?.apiName,
      description: params?.description,
      appId: params?.appId,
      methodType: params?.methodType?.toUpperCase(),
    });
    if (response?.status === 201) {
      return response?.data;
    } else {
      throw new Error(response?.data?.error);
    }
  },
);

export const editApi = createAsyncThunk("editApi/save", async (params: any) => {
  const response = await axiosInstance.put("/featsetup/api", {
    id: params.id,
    endpointPath: params.endpointPath,
    apiName: params.apiName,
    description: params.description,
    appId: params.appId,
    methodType: params?.methodType?.toUpperCase(),
  });
  if (response.data.status === true) {
    return response.data;
  }
  if (response.data.status === false) {
    throw new Error(response.data.error);
  }
});

export const deleteApi = createAsyncThunk(
  "deleteApi/remove",
  async (id: number) => {
    const data = { ids: [id?.toString()] };
    const response = await axiosInstance.delete(`/featsetup/api`, {
      data,
    });
    if (response.data.status === true) {
      return response.data;
    }
    if (response.data.status === false) {
      throw new Error(response.data.error);
    }
  },
);

export type createApiState = {
  data: "";
  createStatus: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
  editStatus: "idle" | "loading" | "succeeded" | "failed";
  editError: string | null;
  deleteStatus: "idle" | "loading" | "succeeded" | "failed";
  deleteError: string | null;
};

const initialState: createApiState = {
  data: "",
  createStatus: "idle",
  error: null,
  editStatus: "idle",
  editError: null,
  deleteStatus: "idle",
  deleteError: null,
};

const createApiSlice = createSlice({
  name: "createOrEditApi",
  initialState,
  reducers: {
    resetCreateStatus: (state) => {
      state.createStatus = "idle";
      state.error = null;
    },
    resetEditStatus: (state) => {
      state.editStatus = "idle";
      state.editError = null;
    },
    resetDeleteStatus: (state) => {
      state.deleteStatus = "idle";
      state.deleteError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createApi.pending, (state) => {
        state.createStatus = "loading";
      })
      .addCase(createApi.fulfilled, (state, action: PayloadAction<any>) => {
        state.createStatus = "succeeded";
        state.data = action.payload;
      })
      .addCase(createApi.rejected, (state, action) => {
        state.createStatus = "failed";
        state.error = action.error.message || null;
      })
      .addCase(editApi.pending, (state) => {
        state.editStatus = "loading";
      })
      .addCase(editApi.fulfilled, (state, action: PayloadAction<any>) => {
        state.editStatus = "succeeded";
        state.data = action.payload;
      })
      .addCase(editApi.rejected, (state, action) => {
        state.editStatus = "failed";
        state.editError = action.error.message || null;
      })
      .addCase(deleteApi.pending, (state) => {
        state.deleteStatus = "loading";
      })
      .addCase(deleteApi.fulfilled, (state, action: PayloadAction<any>) => {
        state.deleteStatus = "succeeded";
        state.data = action.payload;
      })
      .addCase(deleteApi.rejected, (state, action) => {
        state.deleteStatus = "failed";
        state.deleteError = action.error.message || null;
      });
  },
});

export const { resetCreateStatus, resetEditStatus, resetDeleteStatus } =
  createApiSlice.actions;
export default createApiSlice.reducer;
